(function () {
    'use strict';

    function init(block) {
        var track = block.querySelector('[data-news-listing-track]');
        var prevBtn = block.querySelector('[data-news-listing-prev]');
        var nextBtn = block.querySelector('[data-news-listing-next]');
        if (!track) {
            return;
        }

        function step() {
            var first = track.querySelector('.block-news-listing__card');
            if (!first) {
                return track.clientWidth;
            }
            var styles = window.getComputedStyle(track);
            var gap = parseFloat(styles.columnGap || styles.gap) || 0;
            return first.offsetWidth + gap;
        }

        function update() {
            if (!prevBtn || !nextBtn) return;
            var max = track.scrollWidth - track.clientWidth;
            prevBtn.disabled = track.scrollLeft <= 1;
            nextBtn.disabled = track.scrollLeft >= max - 1;
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', function () {
                track.scrollBy({ left: -step(), behavior: 'smooth' });
            });
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', function () {
                track.scrollBy({ left: step(), behavior: 'smooth' });
            });
        }
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        requestAnimationFrame(update);

        // Drag-to-scroll. Cards are <a> links, so a plain click must pass
        // through to the anchor — we only enter drag mode once the pointer
        // moves past a small threshold, and swallow the synthetic click that
        // follows a real drag so the link doesn't navigate at the end of a
        // swipe. Native image-drag is suppressed via dragstart instead of a
        // blanket preventDefault on pointerdown (which also kills the click).
        var DRAG_THRESHOLD = 5;
        var isPointerDown = false;
        var isDragging = false;
        var startX = 0;
        var startScrollLeft = 0;
        var activePointerId = null;

        track.addEventListener('dragstart', function (e) { e.preventDefault(); });

        track.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'touch') return;
            isPointerDown = true;
            isDragging = false;
            startX = e.clientX;
            startScrollLeft = track.scrollLeft;
            activePointerId = e.pointerId;
        });

        track.addEventListener('pointermove', function (e) {
            if (!isPointerDown) return;
            var dx = e.clientX - startX;
            if (!isDragging) {
                if (Math.abs(dx) < DRAG_THRESHOLD) return;
                isDragging = true;
                try { track.setPointerCapture(activePointerId); } catch (_) { /* ignore */ }
                track.style.cursor = 'grabbing';
            }
            track.scrollLeft = startScrollLeft - dx;
        });

        function endDrag() {
            if (!isPointerDown) return;
            isPointerDown = false;
            try { track.releasePointerCapture(activePointerId); } catch (_) { /* already released */ }
            track.style.cursor = '';
            if (isDragging) {
                isDragging = false;
                track.addEventListener('click', function suppress(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                }, { capture: true, once: true });
            }
            activePointerId = null;
        }

        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
    }

    function ready() {
        document.querySelectorAll('.block-news-listing').forEach(init);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ready);
    } else {
        ready();
    }
})();
